import $ from 'jquery';

class Modal{

    constructor(args){

        this.args = args;

        this.speed = 300;

        this.isModalOpen = false;

        this.dialog = document.createElement('div');

        $(this.dialog).html(this.template());

        $("body").append(this.dialog);

        this.showModal();
        
        this.events();

    }

    events(){

        if(this.args.confirm){

            $(this.dialog).find('#confirm').on('click', ()=>{

                this.args.confirm.callback?.();

                this.removeModal();

            });

            setTimeout(()=> $(this.dialog).find('#confirm').focus(), (this.speed + 100));
        }
        if(this.args.cancel){

            $(this.dialog).find('#cancel').on('click', ()=>{

                this.args.cancel.callback?.();

                this.removeModal();

            });
            
        }
        if(this.args.alert){
            
            $(document).on("keydown", (event)=> this.keyPressDispatcher(event) );
            
            $(this.dialog).find('.modal-overlay').on('click', ()=>{
    
                this.removeModal();
    
            });


        }
        
    }

    keyPressDispatcher(event){

        if(event.keyCode == 27 && this.isModalOpen){

            this.removeModal();

        }
        
    }

    showModal(){

        $(this.dialog).find('.modal-overlay, .modal-dialog').fadeIn(this.speed,()=>{

            this.isModalOpen = true;

        }); 

    }

    removeModal(){

        $(this.dialog).find('.modal-overlay, .modal-dialog').fadeOut(this.speed,()=>{

            this.isModalOpen = false;

            $(this.dialog).remove();

        });        

    }

    template(){
       
        return `

            <div class="modal-overlay"></div>
            <div class="modal-dialog">
                <div class="modal-dialog__header">
                   ${this.args.header?`<h2>${this.args.header}</h2>`:''}
                </div>
                <div class="modal-dialog__body">
                    ${this.args.content?`${this.args.content}`:''}
                </div>
                <div class="modal-dialog__footer">
                    ${this.args.confirm?`<button id='confirm'>${this.args.confirm.label}</button>`:''}
                    ${this.args.cancel?`<button id='cancel'>${this.args.cancel.label}</button>`:''}                   
                </div>
            </div>           
            
        `;

    }

}

export default Modal;